export enum FlowModes {
  DEFAULT = 'default',
  RESCHEDULE = 'reschedule',
  CANCEL = 'cancel',
  CONFIRM = 'confirm',
}
